import { HtmlBlock } from '@/cms/definitions/content-types';
import BuyInsuranceSettings from '../BuyInsuranceSettings';
import { exception } from '@/appinsights/logging/ApplicationInsightLog';

export const productAccidentId = 'SS1VUF9VUC0yOA==';
export class FamilySettings extends BuyInsuranceSettings {
	// INDBO
	public sumsLabel: string;
	public sumsSelectDefault: string;
	public extendedBikeSum = '39392';
	// ULYKKE
	public work: Array<string> = [];
	public workIds: Array<string> = [];
	public personCountList: Array<string> = [];
	public showWorkForMinors = false;
	public workForMinorsLabel: string;
	public useAdultAccident = false;
	public familyMemberInfo: string;
	public minChildAge = 1;
	public childAgeSports = 4;
	public personCountPopupTitle: string;
	public personCountPopupContent: string;
	public childCprPopover: string;

	public constructor(settingsBlock: HtmlBlock) {
		super(settingsBlock);
		this.loadFamilySettings();
	}

	/**
	 * load settings from CMS if present
	 */
	private loadFamilySettings() {
		try {
			let setting: string;
			const settingsArr = this.settingsBlock.markup.split('$');
			settingsArr.forEach((setting_) => {
				setting = setting_.toLowerCase().trim();
				if (setting.startsWith('sumslabel=')) {
					this.sumsLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('sumsselectdefault=')) {
					this.sumsSelectDefault = this.getSettingsValue(setting_);
				} else if (setting.startsWith('work=')) {
					this.work = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('workids=')) {
					this.workIds = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('personcountlist=')) {
					this.personCountList = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('showworkforminors=')) {
					this.showWorkForMinors = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('workforminorslabel=')) {
					this.workForMinorsLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('useadultaccident=')) {
					this.useAdultAccident = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('familymemberinfo=')) {
					this.familyMemberInfo = this.getSettingsValue(setting_);
				} else if (setting.startsWith('extendedbikesum=')) {
					this.extendedBikeSum = this.getSettingsValue(setting_);
				} else if (setting.startsWith('minchildage=')) {
					this.minChildAge = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('childagesports=')) {
					this.childAgeSports = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('personcountpopuptitle=')) {
					this.personCountPopupTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('personcountpopupcontent=')) {
					this.personCountPopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('childcprpopover=')) {
					this.childCprPopover = this.getSettingsValue(setting_);
				}
			});
		} catch (e) {
			exception(e);
		}
	}
}
